import {
  clearStableRequest,
  getBrowserStorage,
  getOrCreateStableRequest,
} from '../../../../services/stableRequestId'

const REQUEST_PREFIX = 'specific:planet-hd-ambient-cancel'

const getLocalStorage = () => getBrowserStorage('localStorage')

export const getOrCreatePlanetHdAmbientCancelRequest = (
  {ambientId, landId, source},
  storage = getLocalStorage(),
  createId
) => getOrCreateStableRequest(
  REQUEST_PREFIX,
  {
    ambientId: String(ambientId || 'active'),
    landId: String(landId),
    source: String(source),
  },
  storage,
  createId
)

export const clearPlanetHdAmbientCancelRequest = (
  storageKey,
  storage = getLocalStorage()
) => clearStableRequest(storageKey, storage)

export const buildPlanetHdAmbientCancelPayload = (requestId) => ({
  action: 'cancel',
  idempotency_key: requestId,
  request_id: requestId,
})
